export const easyAccountDataKey = 'EasyAccountData';

export interface IEasyAccountData {
  id: number;
  pub: string;
  priv: string;
  name: string;
  isLoggedIn: boolean;
}
